export default {"src":"/_next/static/media/audio_pause.79475d99.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};